import { Box, ColorOptions, Text } from '@jfs/ui-new'
import { values } from 'mobx'
import { ModBox } from '../../comps/ModifiedBox/ModifiedBox'
import { SvgImage } from '../../comps/SvgImage'
import { ToastPosition, ToastType } from '../../comps/Toast'
import { RootStore } from '../../data/store'
import { Colors } from '../../util/util.web'

interface TextWithCopyPops {
  text: string
  showCopyIcon: boolean
  TextComp?: any
}

export const TextWithCopy = ({ text, showCopyIcon = false, TextComp }: TextWithCopyPops) => {
  const copyToClipBoard = () => {
    navigator.clipboard.writeText(text)
    // RootStore.response.setToastType('POSITIVE')
    // RootStore.response.setMessage('Copied to clipboard.', 'POSITIVE')
    RootStore?.response?.setCustomToast({
      color: 'GREEN',
      message: 'Copied to clipboard.',
      position: ToastPosition.BOTTOM,
      toastType: ToastType.POSITIVE,
    })
  }
  return (
    <Box flexDirection={'row'} alignItems={'center'}>
      <ModBox
        height={60}
        overflow={'auto'}
        nativeID={showCopyIcon ? 'persistantScroll' : undefined}
        flex={1}
        show={!TextComp ? true : false}>
        <Text title={text} fontSize={14} lineHeight={21} fontFamily={'jiotype-medium'} />
      </ModBox>
      <ModBox
        height={60}
        overflow={'auto'}
        nativeID={showCopyIcon ? 'persistantScroll' : undefined}
        flex={1}
        show={TextComp ? true : false}>
        {TextComp}
      </ModBox>

      <ModBox
        onPress={copyToClipBoard}
        testID={'copyToClipBoard'}
        disabled={values.length === 0}
        underlayColor="TRANSPARENT"
        p={8}
        marginLeft={12}
        h={24}
        show={showCopyIcon}
        justifyContent={'center'}
        align={'center'}
        borderRadius={4}
        bg={Colors.BG_BLUE_LIGHT as ColorOptions}>
        <SvgImage imageName={'copy'} width={8} height={8} color={'#2269fc'} />
      </ModBox>
    </Box>
  )
}
